import DE_APP_CONFIG_CHECKER_PAGE_CONSTANTS from './de'
import EN_APP_CONFIG_CHECKER_PAGE_CONSTANTS from './en'
import FR_APP_CONFIG_CHECKER_PAGE_CONSTANTS from './fr'
import HU_APP_CONFIG_CHECKER_PAGE_CONSTANTS from './hu'
import { T_APP_CONFIG_CHECKER_PAGE_CONSTANTS } from './TYPES'

import { T_GENERIC_LANGUAGE_MAP } from '~/src/Constants/LANGUAGE'

import objectPathFactory from '~/src/Lib/objectPathFactory'

const APP_CONFIG_CHECKER_PAGE_CONSTANTS: T_GENERIC_LANGUAGE_MAP<T_APP_CONFIG_CHECKER_PAGE_CONSTANTS> =
  {
    hu: HU_APP_CONFIG_CHECKER_PAGE_CONSTANTS,
    en: EN_APP_CONFIG_CHECKER_PAGE_CONSTANTS,
    fr: FR_APP_CONFIG_CHECKER_PAGE_CONSTANTS,
    de: DE_APP_CONFIG_CHECKER_PAGE_CONSTANTS
  }

export default APP_CONFIG_CHECKER_PAGE_CONSTANTS

export const APP_CONFIG_CHECKER_PAGE_CONSTANTS_PATH =
  objectPathFactory<T_APP_CONFIG_CHECKER_PAGE_CONSTANTS>()
